import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ProductsPage from '@/pages/about/page';
import ContactPage from '@/pages/contact/page';
import LogoPreviewPage from '@/pages/logo-preview/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/products', element: <ProductsPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/logo-preview', element: <LogoPreviewPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
